import sliceCreator from '../../index.js';
import {RESET_PASSWORD} from '../../../constants/index.js';
const _resetPasswordAction = sliceCreator('RESET_PASSWORD', RESET_PASSWORD, 'post');

const { asyncAction: resetPasswordAction, reducer, clearData: clearResetPasswordAction } = _resetPasswordAction;

export default reducer;

export {
    resetPasswordAction,
    clearResetPasswordAction
}